import React, { useState, useEffect } from 'react';
import './Navbar.css';

const links = [
  { id: 'home', label: 'Home' },
  { id: 'about', label: 'About' },
  { id: 'services', label: 'Services' },
  { id: 'reviews', label: 'Reviews' },
  { id: 'contact', label: 'Contact' },
];

export default function Navbar({ page, navigate }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const go = (p) => { navigate(p); setOpen(false); };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`} aria-label="Main navigation">
      <div className="nav-inner container">
        <button className="nav-logo" onClick={() => go('home')} aria-label="Cardona Auto Detailing — go to homepage">
          <img src="/logo.png" alt="Cardona Auto Detailing" className="nav-logo-img" />
        </button>
        <ul id="nav-menu" className={`nav-links ${open ? 'open' : ''}`}>
          {links.map(l => (
            <li key={l.id}>
              <button
                className={`nav-link ${page === l.id ? 'active' : ''}`}
                onClick={() => go(l.id)}
                aria-current={page === l.id ? 'page' : undefined}
              >
                {l.label}
              </button>
            </li>
          ))}
          <li>
            <button className="nav-cta" onClick={() => go('reservations')}>
              Book Now
            </button>
          </li>
        </ul>

        <button
          className="hamburger"
          onClick={() => setOpen(!open)}
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
          aria-controls="nav-menu"
        >
          <span className={open ? 'x' : ''} aria-hidden="true"></span>
          <span className={open ? 'x' : ''} aria-hidden="true"></span>
          <span className={open ? 'x' : ''} aria-hidden="true"></span>
        </button>
      </div>
    </nav>
  );
}
